import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { t } from "i18next"
import { RadioGroup } from "@/components/ui/radio-group"
import { NewsForm } from "@/modules/admin/news/types"
import { RadioGroupItemCustom } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-group-item"
import { CriticalityLevel } from "@/types/__generated__/union-types"

type LevelCriticalityItem = {
  label: string
  value: CriticalityLevel
}

const sortedCriticalityLevels: CriticalityLevel[] = ["INFO", "WARNING", "CRITICAL"]
const sortedCriticalityLevelsWithLabel: LevelCriticalityItem[] = sortedCriticalityLevels.map((e) => ({
  label: t(`admin.news.criticalityLevel.${e.toLowerCase()}`),
  value: e,
}))

const NewsSectionUserLevelCriticalityForm = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<NewsForm>()

  return (
    <div className="flex flex-col gap-2">
      <label className="text-on-surface-subdued text-sm">{t("admin.news.criticalityLevelTitle")}*</label>
      <Controller
        control={control}
        name="criticalityLevel"
        render={({ field: { value, onChange } }) => (
          <RadioGroup value={value} defaultValue="INFO" className="flex flex-wrap gap-2" onValueChange={onChange}>
            {sortedCriticalityLevelsWithLabel.map((criticalityLevel) => {
              const { value, label } = criticalityLevel
              return <RadioGroupItemCustom key={value} value={value} groupName="news-criticality-level" label={label} />
            })}
          </RadioGroup>
        )}
      />
    </div>
  )
}

export { NewsSectionUserLevelCriticalityForm }
